import appConstants  from './app-constants';

export default {
    findDiffBetweenTwoObjects(category, oldObj, newObj){
        var resultArr = this.diff(oldObj, newObj, category);
        if(!resultArr || Object.keys(resultArr).length == 0) { return "" }
        var before = JSON.parse(JSON.stringify(resultArr));
        var after = JSON.parse(JSON.stringify(resultArr));

        const iterate = (obj, k) => {
            Object.keys(obj).forEach(key => {
            if(!obj[key] && key != k) return;
            if(key == 'type' || key == k) 
            delete obj[key]

            if (typeof obj[key] === 'object') {
                    iterate(obj[key], k)
                }
            });
        }
        iterate(before, 'updated')
        iterate(after, 'original')

        const changeObjToVal = (obj) => {
            var contextList = []
            contextList = this.getContextInclusionList(obj, contextList);
            Object.keys(obj).forEach(key => {
                if(obj[key] === null || obj[key].original === null || obj[key].updated === null)
                    obj[key] = undefined
                
                else if(!obj[key])
                    return

                else if((obj[key] === "" || obj[key].original === "" ||  obj[key].updated === "") && !contextList.includes(key))
                    obj[key] = undefined

                else if ((obj[key] == 0 && obj[key] != '') || (obj[key].original == 0 && obj[key].original != '') || (obj[key].updated == 0 && obj[key].updated != ''))
                    obj[key] = 0

                else if(obj[key] && Object.keys(obj[key]).length === 0)
                    obj[key] = undefined

                else if(obj[key] && obj[key].original !== undefined)  
                    obj[key] = obj[key].original

                else if(obj[key] && obj[key].updated !== undefined)  
                    obj[key] = obj[key].updated

                else if (typeof obj[key] === 'object' && Object.keys(obj[key]).length > 0) {
                    changeObjToVal(obj[key])
                }
            })
        }
        changeObjToVal(before)
        changeObjToVal(after)
        
        this.RemovedProperties(before, category);
        this.RemovedProperties(after, category);

        return { Before: before, After: after};
    },
    getActionTypeByParentUniqueID(oldObj, newObj, before,after){
        var uniqueID = appConstants.ParentUniqueIDs.filter(x=>  newObj[x] !== undefined)[0];
        if(JSON.stringify(before) == '{}') 
            return {actionType: "Insert", uniqueIdentifier: uniqueID ? newObj[uniqueID] : 0 }
        else if(JSON.stringify(after) == '{}')
            return {actionType: "Delete", uniqueIdentifier:  uniqueID ? oldObj[uniqueID] : 0}
        else
            return  {actionType: "Update", uniqueIdentifier: uniqueID ? newObj[uniqueID] : 0}
        
    },
    RemovedProperties(obj, category){
        Object.keys(obj).forEach(key => {
            var tempKey = key;
            if(obj[key] && typeof obj[key] == 'object'){
                Object.keys(obj[key]).forEach(k=> {
                    if(Object.prototype.toString.call(k) === '[object Object]'){
                        this.RemovedProperties(k,category);
                    }
                    else if(obj[tempKey] && obj[tempKey][k] && Object.prototype.toString.call(obj[tempKey][k]) === '[object Object]'){
                        this.RemovedProperties(obj[tempKey][k],category);
                        if(obj[tempKey][k] == undefined || (obj[tempKey][k] && JSON.stringify(obj[tempKey][k]) == '{}'))
                            delete obj[tempKey][k]
                    }
                    else if(obj[tempKey] && obj[tempKey][k] && Object.prototype.toString.call(obj[tempKey][k]) === '[object Array]'){
                        Object.values(obj[tempKey][k]).forEach(x=> {
                            this.RemovedProperties(x,category);
                            if(obj[tempKey][k] == undefined || (obj[tempKey][k] && JSON.stringify(obj[tempKey][k]) == '{}'))
                                delete obj[tempKey][k]
                        });
                    }
                    else if(!obj[tempKey] || (obj[tempKey] && JSON.stringify(obj[tempKey]) == '{}'))
                        delete obj[tempKey]
                    else if(obj[tempKey] && !obj[tempKey][k] || obj[tempKey][k] == ""){
                        delete obj[tempKey][k];
                        if(obj[tempKey] == undefined || (obj[tempKey] && JSON.stringify(obj[tempKey]) == '{}'))
                            delete obj[tempKey]
                    }
                    else if(obj[tempKey] && ((!isNaN(obj[tempKey][k]) && obj[tempKey][k] >= 0) || obj[tempKey][k] || !obj[tempKey][k])){
                        this.getOmissionList(k, category).forEach(r=> {
                            if(obj[tempKey]){
                                delete obj[tempKey][k]
                                delete obj[tempKey][r]
                            }
                            if(obj[tempKey] == undefined || (obj[tempKey] && JSON.stringify(obj[tempKey]) == '{}'))
                                delete obj[tempKey]
                        });
                    }
                    else if(obj[tempKey] && !obj[tempKey][k] && Object.keys(obj[tempKey]).length == 1)
                        delete obj[tempKey]
                });
                if(!obj[tempKey] || Object.values(obj[tempKey]).length == 1 && JSON.stringify(Object.values(obj[tempKey])[0]) == '{}')
                    delete obj[tempKey]
                if(obj[tempKey] && JSON.stringify(Object.values(obj[tempKey])) == '[]')
                    delete obj[tempKey]
            }
            else if((!isNaN(obj[key]) && obj[key] >= 0) || obj[key] || !obj[key]){
                this.getOmissionList(key, category).forEach(r=> {
                    if(obj){
                        delete obj[key]
                        delete obj[r]
                    }
                });
            }
        });
    },
    getOmissionList(obj, category){ 
        var remvoedListByCategory = [];
        var removedCommonList = []; 
        if(appConstants.OmissionPropertyList[category])
        remvoedListByCategory = appConstants.OmissionPropertyList[category].filter(x=> obj && obj.toLowerCase() == x.toLowerCase());
        if(appConstants.OmissionPropertyList['common']) 
        removedCommonList = appConstants.OmissionPropertyList['common'].filter(x=> obj && obj.toLowerCase() == x.toLowerCase());
        return removedCommonList.concat(remvoedListByCategory);
    },
    diff(obj1, obj2, category, keyName1, keyName2){
        if (this.isFunction(obj1) || this.isFunction(obj2)) {
            throw 'Invalid argument. Function given, object expected.';
        }
        if (this.isValue(obj1) || this.isValue(obj2)) {
            var omissionListByCategory = appConstants.OmissionPropertyList[category];
            var omissionListCommon = appConstants.OmissionPropertyList['common'];
            omissionListCommon = omissionListCommon.concat(omissionListByCategory);
            if(!omissionListCommon.find(f=> f == keyName1 || f == keyName2)){
                let returnObj = {
                    type: this.compareValues(obj1, obj2),
                    original: obj1,
                    updated: obj2,
                };
                if (returnObj.type != '---') {
                    return returnObj;
                }
            }
            return undefined;
        }   

        var diff = {};
        for (var key in obj1) { 
            if (this.isFunction(obj1[key])) {
                continue;
            }
            // find uniqueID from the array 
            var uniqueId = appConstants.UniqueKeyPropertyList.filter(x=>  obj1[key] && (obj1[key][x] !== undefined || x == key))[0];
            var val2  = undefined;
            if(uniqueId){
                if(Object.keys(obj2).filter(y => Number.isInteger(parseInt(y,10)) !== true).length > 0)
                    val2 = obj2[key];
                else if(obj2[key] && obj2[key][uniqueId] && obj2[key][uniqueId] == obj1[key][uniqueId])
                    val2 = obj2[key];
                else if(!obj2[key] && obj2[uniqueId] && obj2[uniqueId] == obj1[key][uniqueId]){
                    val2 = obj2;
                }
                else { 
                    val2 = obj2.find(x=> x[uniqueId] == obj1[key][uniqueId]);
                } 
            }
            else 
                val2 = obj2[key]; 

            let mapValue = this.diff(obj1[key], val2, category, key, val2 !== undefined ? key : undefined);                
            if (mapValue) {
                diff[key] = mapValue;
            }
        }
        for (var k in obj2) { 
            if (this.isFunction(obj2[k])) {
                continue;
            } 
            var uniqueID = appConstants.UniqueKeyPropertyList.filter(x=> obj2[k] &&  (obj2[k][x] !== undefined || x == k))[0];
            var isAdded = false;
            if(uniqueID){
                var data = obj2[k] && obj2[k][uniqueID] == 0 ? obj2[k] : undefined;
                if(data !== undefined && data.hasOwnProperty(uniqueID) && data[uniqueID] == '0' && obj1 && obj1.length > 0 && obj1.filter(f=> f[uniqueID] == data[uniqueID]).length == 0 )
                {
                    let mapValue = this.diff(undefined, data, category, k, k);
                    let check = Object.keys(diff).filter(y => Number.isInteger(parseInt(y,10)) !== true).length > 0;
                    if (mapValue) {
                        if(check)
                            diff[k] = mapValue;
                        else{
                            var index =  isNaN(Object.keys(diff)[Object.keys(diff).length - 1]) ? (Object.keys(diff)[Object.keys(diff).length - 1]): parseInt(Object.keys(diff)[Object.keys(diff).length - 1]) ;
                            diff[index >= 0 ? index + 1 : Object.keys(diff).length + 1] = mapValue;
                        }
                    }
                    isAdded = !isAdded;
                }
                else if(obj1.length == 0 || obj1.length > 0 && obj1.filter(f=> f[uniqueID] == obj2[k][uniqueID]).length == 0){
                    let mapObjValue = this.diff(undefined, obj2[k], category, k, k);
                    if(mapObjValue){
                        var id =  isNaN(Object.keys(diff)[Object.keys(diff).length - 1]) ? (Object.keys(diff)[Object.keys(diff).length - 1]): parseInt(Object.keys(diff)[Object.keys(diff).length - 1]) ;
                        diff[id >= 0 ? id + 1 : k]  = mapObjValue;
                    }
                    isAdded = !isAdded;
                }
            }
            if(isAdded == false && obj1 && this.isObject(obj1) &&  obj1[k] === undefined && obj2[k] !== undefined){
                let mapObjValue = this.diff(undefined, obj2[k], category, k ,k);
                if(mapObjValue){
                    var diffIndex = isNaN(Object.keys(diff)[Object.keys(diff).length - 1]) ? (Object.keys(diff)[Object.keys(diff).length - 1]): parseInt(Object.keys(diff)[Object.keys(diff).length - 1]);
                    diff[diffIndex >= 0 ? diffIndex + 1 : k]  = mapObjValue;
                }
            }
        }
        
        if (Object.keys(diff).length > 0) {
            var contextList  = [];
            contextList = this.getContextInclusionList(obj1, contextList);
            diff = this.removeDuplicateDataFromDiff(diff,contextList, category )
            contextList.forEach(name=>{
                    diff =   this.includeContextName(name, diff, obj1, obj2);
            });
                
            return diff;
        }
        return undefined;
    },
    removeDuplicateDataFromDiff(diff, contextList, category){
        Object.keys(diff).forEach(x=> {
            if(diff[x] && !diff[x].type && this.isObject(diff[x])){
                Object.keys(diff[x]).forEach(k=> {
                    var isDuplicate = Object.values(diff[x]).filter(s=> s && s.type && s.type == 'updated' && s.original != s.updated).length == 0;
                    if(isDuplicate && diff[x][k] && diff[x][k].original== diff[x][k].updated && diff[x][k].type == "updated")
                        delete diff[x][k];
                    else{
                        this.getOmissionList(k, category).forEach(r=> {
                            if(diff[x][k] && !contextList.includes(k)){
                                delete diff[x][k]
                                delete diff[x][r]
                            }
                        });
                    }
                });
            }
            else if(!contextList || contextList.filter(c=> x == c && diff[c]).length == 0){
                if(diff[x] && diff[x].original== diff[x].updated && diff[x].type == "updated")
                    delete diff[x];
                else if(diff[x] && this.isObject(diff[x])){
                    Object.keys(diff[x]).forEach(n=>{
                        var isDuplicate = Object.values(diff[x]).filter(s=> s && s.type && s.type == 'updated' && s.original != s.updated).length == 0
                        if(isDuplicate && diff[x][n] && diff[x][n].type && diff[x][n].type == "updated" && diff[x][n].original == diff[x][n].updated)
                            delete diff[x][n];
                        else{
                            this.getOmissionList(n, category).forEach(r=> {
                                if(diff[x][n] && !contextList.includes(n)){
                                    delete diff[x][n]
                                    delete  diff[x][r]
                                }
                            });
                        }
                    });
                }
            }
        });
        return diff;
    },
    getContextInclusionList(obj1, contextNames){
        var contextList = appConstants.ContextPropertyInclusionList;
        if(Object.keys(obj1).filter(y => Number.isInteger(parseInt(y,10)) == true).length == 0){
            var dataList =  contextList.filter(x=> obj1[x] !== undefined); 
            contextNames =  contextNames.concat(dataList);
            return contextNames;
        }
        else{
            var data = [];
            Object.keys(obj1).forEach(k=>{
                data = this.getContextInclusionList(obj1[k], contextNames);
                data = data.concat(contextNames);
            });
            return data;
        }
    },
    includeContextName(name, diff, obj1, obj2){
        if(Object.keys(diff).filter(y => Number.isInteger(parseInt(y,10)) == true).length == 0){
            if(name && !diff[name]){
                if(obj1[name] !== undefined){
                    diff[name]  = { 
                        type: 'updated',
                        original : obj1[name],
                        updated :obj1[name]
                    }
                    return diff;
                }
                else{
                    var contextInclusionChildName = appConstants.ContextInclusionChilList.find(f=> diff[f] && (diff[f].original || diff[f].updated))
                    var keys = Object.keys(diff) ? Object.keys(diff): '';
                    var key = keys.find(k=> contextInclusionChildName == k);
                    var filteredOriginalData = obj1.filter(x=> key && x[key] == diff[key].original);
                    var filteredUpdatedData = obj2.filter(x=> key && x[key] == diff[key].updated);
                    var filteredName = filteredOriginalData.find(f=> filteredUpdatedData.some(n=> n[name] == f[name]))
                    if(filteredName && filteredName[name] !== undefined){
                        diff[name]  = { 
                            type: 'updated',
                            original : filteredName[name],
                            updated : filteredName[name]
                        }
                        return diff;
                    }
                }
                return diff;
            }
            return diff;
        }
        else{
            Object.keys(diff).forEach(k=>{
                diff[k] = this.includeContextName(name, diff[k], obj1, obj2);
            });
            return diff;
        }

    },
    compareValues (value1, value2) {
        if (value1 === value2) {
            return '---';
        }
        if (value1 == value2) {
            return '---';
        }
        if (this.isDate(value1) && this.isDate(value2) && value1.getTime() === value2.getTime()) {
            return '---';
        }
        if (value1 === undefined) {
            return 'created';
        }
        if (value2 === undefined) {
            return 'deleted';
        }
        return 'updated';
    },
    isFunction: function (x) {
        return Object.prototype.toString.call(x) === '[object Function]';
    },
    isArray: function (x) {
        return Object.prototype.toString.call(x) === '[object Array]';
    },
    isDate: function (x) {
        return Object.prototype.toString.call(x) === '[object Date]';
    },
    isObject: function (x) {
        return Object.prototype.toString.call(x) === '[object Object]';
    },
    isValue: function (x) {
        return !this.isObject(x) && !this.isArray(x);
    }
}